import 'react-datepicker/dist/react-datepicker.css';

import moment from 'moment-timezone';
import React from 'react';
import DatePicker from 'react-datepicker';
import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';

import countryCodes from '../../../assets/js/countryCodes';
import AvatarEditorContainer from '../../../containers/AccountSettingsContainer/avatarEditorContainer';
import ChangeRatingExamContainer from '../../../containers/AccountSettingsContainer/changeRatingExamContainer';
import { containsProfanity } from '../../../utils/containsProfanity';
import { validateEmail as validateE } from '../../../utils/validateEmail';
import validatePassword from '../../../utils/validatePassword';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import ChooseQualDailyQuiz from './ChooseQualDailyQuiz';
import StudySpeedSettingsSection from './components/StudySpeedSettingsSection';
import FlashcardOnlySection from './FlashcardOnlySection';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

class MyProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rateSelectorIsOpen: false,
      selectedRate: { name: '', id: 0 },
      timezoneSelectorIsOpen: false,
      timezone: { name: '', abbrs: [''] },
      selectedRatingExam: { name: 'HM2 Regular March 2019' },
      allowEditRatingExam: false,
      allowEditEmail: false,
      allowEditUsername: false,
      usernameValidInput: true,
      emailValidInput: true,
      isEditingPassword: false,
      username: '',
      email: '',
      messageType: null,
      selectedImage: null,
      oldPasswordValidInput: true,
      newPasswordValidInput: true,
      oldPassword: '',
      newPassword: '',
      showPassword: false,
      loadPossibleCyclesForUserCalled: false,
      isEmail: false,
      phoneNumber: '',
      countryCode: '',
      currentEnrollmentStatus: '',
      highestEducationLevel: '',
      currentEnrollmentStatusIsOpen: false,
      highestEducationLevelIsOpen: false,
      countryCodeIsOpen: false,
      isEditingPersonalData: false,
      disclaimer: false,
      estimatedDegreeCompletionDate: null,
      validatePasswordError: false,
      showErrors: false,
      cycleSelectorIsOpen: false,
      cycleSelected: null,
      isEditingCycle: false,
      usernameInputError: '',
      nameCurrentEducationalInstitution: null,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.user.id &&
      this.props.possibleCyclesForUser.length === 0 &&
      !this.state.loadPossibleCyclesForUserCalled
    ) {
      this.props.loadPossibleCyclesForUser(nextProps.user);
      this.setState({ loadPossibleCyclesForUserCalled: true });
    }
    // phoneNumber
    if (nextProps.user.phoneNumber) {
      this.setState({ phoneNumber: nextProps.user.phoneNumber });
    }
    // cuontryCode
    if (nextProps.user.countryCode) {
      this.setState({ countryCode: nextProps.user.countryCode });
    } else {
      this.setState({ countryCode: '+1' });
    }
    // currentEnrollmentStatus
    if (nextProps.user.currentEnrollmentStatus) {
      this.setState({
        currentEnrollmentStatus: nextProps.user.currentEnrollmentStatus,
      });
    }
    // highestEducationLevel
    if (nextProps.user.highestEducationLevel) {
      this.setState({
        highestEducationLevel: nextProps.user.highestEducationLevel,
      });
    }
    // estimatedDegreeCompletionDate
    if (nextProps.user.estimatedDegreeCompletionDate) {
      const estimatedDate = new Date(
        Number(nextProps.user.estimatedDegreeCompletionDate),
      );
      this.setState({
        estimatedDegreeCompletionDate: estimatedDate,
      });
    }
    // nameCurrentEducationalInstitution
    if (nextProps.user.nameCurrentEducationalInstitution) {
      this.setState({
        nameCurrentEducationalInstitution:
          nextProps.user.nameCurrentEducationalInstitution,
      });
    }
    // username
    if (nextProps.user.username) {
      this.setState({ username: nextProps.user.username });
    }
    // email
    if (nextProps.user.email) {
      this.setState({ email: nextProps.user.email });
    }
    if (nextProps.updateUsernameMessage.text !== '') {
      this.hideMessage(this.props.setUpdateUsernameMessage);
    }
    if (nextProps.updatePersonalDataMessage.text !== '') {
      this.hideMessage(this.props.setUpdatePersonalDataMessage);
    }
    if (nextProps.updateTimezoneMessage.text !== '') {
      this.hideMessage(this.props.setUpdateTimezoneMessage);
    }
    if (nextProps.updateCycleMessage.text !== '') {
      this.hideMessage(this.props.setUpdateCycleMessage);
    }
    if (nextProps.updateEmailMessage.text !== '') {
      this.hideMessage(this.props.setUpdateEmailMessage);
    }
    if (nextProps.updateProfilePrivacyMessage.text !== '') {
      this.hideMessage(this.props.setUpdateProfilePrivacyMessage);
    }
    if (nextProps.flashcardOnlyMessage.text !== '') {
      this.hideMessage(this.props.setFlashcardOnlyMessage);
    }
    if (nextProps.updatePasswordMessage.text !== '') {
      this.hideMessage(this.props.setUpdatePasswordMessage, true);
    }
    // rate
    if (nextProps.user.rate) {
      this.setState({ selectedRate: nextProps.user.rate });
    }
    // timezone
    if (nextProps.user.timezone) {
      const namesList = moment.tz.names();
      const fullZones = namesList.map((name) => moment.tz.zone(name));
      const userZone = fullZones.filter(
        (zone) => zone.name === nextProps.user.timezone,
      );
      if (userZone.length !== 0) {
        this.setState({ timezone: userZone[0] });
      } else {
        this.setState({
          timezone: {
            name: nextProps.user.timezone,
            abbrs: [`${nextProps.user.timezone}`],
          },
        });
      }
    }
    if (nextProps.uploadImageSuccess) {
      // close avatar editor modal
      this.handleFileChange(null);
      this.props.setUploadImageSuccess(false);
    }
    if (nextProps.updateRatingExamSuccess) {
      // close rating exam modal
      this.handleEditRatingExamClick(false);
      this.props.setUpdateRatingExamSuccess(false);
    }
    if (nextProps.uploadImageMessage.text !== '') {
      this.hideMessage(this.props.setUploadImageMessage);
    }
    if (nextProps.updateRatingExamMessage.text !== '') {
      this.hideMessage(this.props.setUpdateRatingExamMessage);
    }
  }

  hideMessage = (functionParam, isPassword = false) => {
    setTimeout(() => {
      functionParam({ type: 'success', text: '' });
      if (isPassword) {
        this.setState({
          oldPassword: '',
          newPassword: '',
          oldPasswordValidInput: true,
          newPasswordValidInput: true,
        });
      }
    }, 7000);
  };

  // SELECTORS HANDLERS

  handleRateSelectorClick = () => {
    this.setState({ rateSelectorIsOpen: !this.state.rateSelectorIsOpen });
  };

  handleRateOptionClick = (rate) => {
    this.setState({ selectedRate: rate });
  };

  handleTimezoneSelectorClick = () => {
    this.setState({
      timezoneSelectorIsOpen: !this.state.timezoneSelectorIsOpen,
    });
  };

  handleCyclesSelectorClick = () => {
    this.setState({
      cycleSelectorIsOpen: !this.state.cycleSelectorIsOpen,
    });
  };

  handleCurrentEnrollmentStatusClick = () => {
    this.setState({
      currentEnrollmentStatusIsOpen: !this.state.currentEnrollmentStatusIsOpen,
    });
  };

  handleCountryCodeClick = () => {
    this.setState({
      countryCodeIsOpen: !this.state.countryCodeIsOpen,
    });
  };

  handleHighestEducationLevelClick = () => {
    this.setState({
      highestEducationLevelIsOpen: !this.state.highestEducationLevelIsOpen,
    });
  };

  handleCurrentEnrollmentStatus = (currentEnrollmentStatus) => {
    this.setState({ currentEnrollmentStatus });
  };

  handleHighestEducationLevel = (highestEducationLevel) => {
    this.setState({ highestEducationLevel });
  };

  handleEstimatedDegreeCompletionDate = (estimatedDegreeCompletionDate) => {
    this.setState({ estimatedDegreeCompletionDate });
  };

  handleNameCurrentEducationalInstitution = (
    nameCurrentEducationalInstitution,
  ) => {
    if (nameCurrentEducationalInstitution.trim() == '') {
      this.setState({ nameCurrentEducationalInstitution: '' });
    } else {
      this.setState({ nameCurrentEducationalInstitution });
    }
  };

  handleTimezoneOptionClick = (zone) => {
    this.props.updateTimezone(zone);
  };

  handleCycleOptionClick = (cycle) => {
    this.setState({
      cycleSelected: cycle,
    });
  };

  // INPUTS HANDLERS

  handleEditRatingExamClick = (value) => {
    if (value) {
      this.props.getAllRates();
    }
    this.setState({ allowEditRatingExam: value });
  };

  handleEditEmailClick = () => {
    this.setState({ allowEditEmail: !this.state.allowEditEmail }, () =>
      this.clickInput('email-input'),
    );
  };

  handleEditUsernameClick = () => {
    this.setState({ allowEditUsername: !this.state.allowEditUsername }, () =>
      this.clickInput('username-input'),
    );
  };

  clickInput = (inputName) => {
    const element = document.getElementById(inputName);
    if (element) {
      element.click();
      element.focus();
    }
  };

  handleChangePasswordClick = () => {
    this.setState({
      isEditingPassword: !this.state.isEditingPassword,
      newPassword: '',
      oldPassword: '',
    });
  };

  handleEditingCycle = () => {
    this.setState({
      cycleSelected: null,
    });
  };

  handleEditPersonalData = () => {
    this.setState({
      isEditingPersonalData: !this.state.isEditingPersonalData,
      disclaimer: false,
    });
  };

  toggleCheckedRadio = (value) => {
    this.props.updateProfilePrivacy(value);
  };

  flashcardCheckedRadio = (value) => {
    this.props.updateFlashcardAction({
      flashcard: value,
      userId: this.props.user.id,
    });
  };

  handleUsernameChange = (username) => {
    this.setState({
      username,
      isEmail: false,
      usernameValidInput: true,
      usernameInputError: '',
    });
  };

  handlePhoneNumber = (phoneNumber) => {
    this.setState({
      phoneNumber,
    });
    if (phoneNumber == '') this.setState({ disclaimer: false });
  };

  handleCountryCode = (countryCode) => {
    this.setState({
      countryCode,
    });
  };

  handleEmailChange = (email) => {
    const emailError = !document.getElementById('email-input').validity.valid;
    this.setState({ emailValidInput: !emailError });
    this.setState({ email });
  };

  handleOldPasswordChange = (oldPass) => {
    this.setState({ oldPassword: oldPass });
  };

  handleNewPasswordChange = (newPass) => {
    this.setState({ newPasswordValidInput: newPass.length >= 6 });
    this.setState({ newPassword: newPass });
  };

  handleFileChange = (file) => {
    this.setState({ selectedImage: file });
  };

  saveImg = (imgFile) => {
    this.props.uploadProfileImage(imgFile);
  };

  renderTimeZoneSelector = () => {
    const namesList = moment.tz.names();
    const fullZones = namesList.map((name) => moment.tz.zone(name));
    return (
      <div className="field">
        <div className="field-label">Time Zone</div>
        <Dropdown
          isOpen={this.state.timezoneSelectorIsOpen}
          toggle={this.handleTimezoneSelectorClick}
          className="my-profile-selector"
        >
          <DropdownToggle className="my-profile-dropdown-toggle">
            <span className="option-title">
              {this.state.timezone.name
                ? `${this.state.timezone.name} (${this.state.timezone.abbrs[0]})`
                : ``}
            </span>
            {this.state.timezoneSelectorIsOpen ? (
              <i className="icon-expand select-icon rotate down" />
            ) : (
              <i className="icon-expand select-icon rotate" />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {fullZones.map((zone) => this.getTimezoneOptions(zone))}
          </DropdownMenu>
        </Dropdown>
        {this.props.updateTimezoneMessage.text !== '' && (
          <div className={`message-${this.props.updateTimezoneMessage.type}`}>
            {this.props.updateTimezoneMessage.text}
          </div>
        )}
      </div>
    );
  };

  validaUserEnrollmentToDate = (enrollmentStatus) => {
    const validUserEnrollmentToDate = [
      'Yes, a certificate program',
      "Yes, an associate's degree program",
      "Yes, a bachelor's degree program",
      "Yes, a master's degree or doctorate program",
    ];
    return validUserEnrollmentToDate.includes(enrollmentStatus);
  };

  renderCurrentEnrollmentStatus = () => {
    const currentEnrollmentStatusOptions = [
      'Yes, a certificate program',
      "Yes, an associate's degree program",
      "Yes, a bachelor's degree program",
      "Yes, a master's degree or doctorate program",
      'No, and I am not interested in enrolling in a degree program in the future',
      'No, but I am interested in enrolling in the future',
    ];

    return (
      <div className="field">
        <div className="field-label">
          {this.state.isEditingPersonalData
            ? 'Current Enrollment Status (*)'
            : 'Current Enrollment Status'}
        </div>
        <Dropdown
          isOpen={this.state.currentEnrollmentStatusIsOpen}
          toggle={this.handleCurrentEnrollmentStatusClick}
          className="my-profile-selector"
          disabled={!this.state.isEditingPersonalData}
        >
          <DropdownToggle
            disabled={!this.state.isEditingPersonalData}
            className={
              this.state.isEditingPersonalData &&
              !this.state.currentEnrollmentStatus &&
              this.state.showErrors
                ? 'my-profile-dropdown-toggle invalid-field'
                : 'my-profile-dropdown-toggle'
            }
          >
            <span
              className={
                this.state.isEditingPersonalData
                  ? 'option-title'
                  : 'option-title-disabled'
              }
            >
              {this.state.currentEnrollmentStatus
                ? this.state.currentEnrollmentStatus
                : ``}
            </span>
            {this.state.isEditingPersonalData &&
              (this.state.currentEnrollmentStatusIsOpen ? (
                <i className="icon-expand select-icon rotate down" />
              ) : (
                <i className="icon-expand select-icon rotate" />
              ))}
          </DropdownToggle>
          <DropdownMenu>
            {currentEnrollmentStatusOptions.map((option, index) => (
              <DropdownItem
                key={index}
                className="drop-item"
                onClick={() => this.handleCurrentEnrollmentStatus(option)}
              >
                {option}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  renderHighestEducationLevel = () => {
    const highestEducationLevelOptions = [
      'High school diploma or GED/HS equivalency',
      'Some college, but no degree',
      'Career / Technical Certificate',
      "Associate's degree",
      "Bachelor's degree",
      "Master's degree or higher",
    ];

    return (
      <div className="field">
        <div className="field-label">
          {this.state.isEditingPersonalData
            ? 'Highest Education Level (*)'
            : 'Highest Education Level'}
        </div>
        <Dropdown
          isOpen={this.state.highestEducationLevelIsOpen}
          toggle={this.handleHighestEducationLevelClick}
          className="my-profile-selector"
          disabled={!this.state.isEditingPersonalData}
        >
          <DropdownToggle
            disabled={!this.state.isEditingPersonalData}
            className={
              this.state.isEditingPersonalData &&
              !this.state.highestEducationLevel &&
              this.state.showErrors
                ? 'my-profile-dropdown-toggle invalid-field'
                : 'my-profile-dropdown-toggle'
            }
          >
            <span
              className={
                this.state.isEditingPersonalData
                  ? 'option-title'
                  : 'option-title-disabled'
              }
            >
              {this.state.highestEducationLevel
                ? this.state.highestEducationLevel
                : ``}
            </span>
            {this.state.isEditingPersonalData &&
              (this.state.highestEducationLevelIsOpen ? (
                <i className="icon-expand select-icon rotate down" />
              ) : (
                <i className="icon-expand select-icon rotate" />
              ))}
          </DropdownToggle>
          <DropdownMenu>
            {highestEducationLevelOptions.map((option, index) => (
              <DropdownItem
                key={index}
                className="drop-item"
                onClick={() => this.handleHighestEducationLevel(option)}
              >
                {option}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  renderEstimatedDegreeCompletionDate = () => {
    const isRequired =
      !this.state.countryCode ||
      !this.state.currentEnrollmentStatus ||
      !this.state.highestEducationLevel ||
      !this.state.phoneNumber ||
      (this.state.phoneNumber &&
        this.isValidPhoneNumber(this.state.phoneNumber) &&
        this.state.phoneNumber != this.props.user.phoneNumber &&
        !this.state.disclaimer) ||
      (this.state.phoneNumber &&
        !this.isValidPhoneNumber(this.state.phoneNumber)) ||
      (this.validaUserEnrollmentToDate(this.state.currentEnrollmentStatus) &&
        (!this.state.nameCurrentEducationalInstitution ||
          !this.state.estimatedDegreeCompletionDate));

    return (
      <div className="field field-input">
        <div className="field-label">
          {this.state.isEditingPersonalData
            ? 'Estimated Degree Completion Date (*)'
            : 'Estimated Degree Completion Date'}
        </div>
        <DatePicker
          dateFormat="MM/yyyy"
          placeholderText="Estimated Date"
          minDate={new Date()}
          disabled={!this.state.isEditingPersonalData}
          selected={this.state.estimatedDegreeCompletionDate}
          onChange={(date) => {
            this.handleEstimatedDegreeCompletionDate(date);
          }}
          showMonthYearPicker
          isClearable={this.state.isEditingPersonalData}
          className={
            !this.state.estimatedDegreeCompletionDate &&
            this.state.showErrors &&
            this.state.isEditingPersonalData
              ? 'my-profile-input invalid-field'
              : 'my-profile-input'
          }
          wrapperClassName={
            this.state.isEditingPersonalData
              ? 'my-profile-input'
              : 'my-profile-input disabled-field'
          }
        />
        <div>
          {this.state.isEditingPersonalData && isRequired && (
            <span className="isRequired">
              All fields marked with (*) are required
            </span>
          )}
        </div>
      </div>
    );
  };

  renderNameCurrentEducationalInstitution = () => (
    <div className="field field-input">
      <div className="field-label">
        {this.state.isEditingPersonalData
          ? 'Name of current Educational Institution (*)'
          : 'Name of current Educational Institution'}
      </div>
      <div
        className={
          !this.state.nameCurrentEducationalInstitution && this.state.showErrors
            ? 'false-input invalid-field'
            : 'false-input'
        }
      >
        <Input
          className={
            this.state.isEditingPersonalData
              ? 'my-profile-input'
              : 'my-profile-input disabled-field'
          }
          disabled={!this.state.isEditingPersonalData}
          placeholder="Name of Current Institution"
          value={this.state.nameCurrentEducationalInstitution}
          onChange={(e) => {
            this.handleNameCurrentEducationalInstitution(
              String(e.target.value),
            );
          }}
        />
      </div>
    </div>
  );

  getCyclesOptions = (cycle) => (
    <DropdownItem
      key={cycle.title}
      className="drop-item"
      onClick={() => this.handleCycleOptionClick(cycle)}
    >
      {`${cycle.description} - ${cycle.title}`}
    </DropdownItem>
  );

  getTimezoneOptions = (zone) => (
    <DropdownItem
      key={zone.name}
      className="drop-item"
      onClick={() => this.handleTimezoneOptionClick(zone)}
    >
      {`${zone.name} (${zone.abbrs[0]})`}
    </DropdownItem>
  );

  // RENDER INPUTS FUNCTIONS
  renderRatingExamInput = () => (
    <div className="field field-input">
      <div className="field-label">AFSC Exam</div>
      <div className="false-input">
        <Input
          className="my-profile-input"
          placeholder={this.getRatingExamText()}
          disabled
        />
        <i className="material-icons warning-icon" id="warning-icon">
          error_outline
        </i>
        {this.canUpdate() && (
          <i
            className="material-icons material-icons-outlined edit-icon"
            onClick={() => this.handleEditRatingExamClick(true)}
          >
            edit
          </i>
        )}
        {!this.canUpdate() && (
          <i className="material-icons material-icons-outlined edit-icon-2">
            edit
          </i>
        )}
      </div>
      <UncontrolledTooltip placement="top" target="warning-icon">
        Heads up! AFSC exam can be changed only once every 30 days.
      </UncontrolledTooltip>
      <ChangeRatingExamContainer
        isOpen={this.state.allowEditRatingExam}
        onClose={() => this.handleEditRatingExamClick(false)}
        onSave={(id, rate, rank, dutyState, cycleSelected) =>
          this.SubmitRatingExamChange(id, rate, rank, dutyState, cycleSelected)
        }
        message={this.props.updateRatingExamMessage}
        waiting={this.props.updateRatingExamWaiting}
        setUploadImageMessage={this.props.setUpdateRatingExamMessage}
        rates={this.props.rates}
        user={this.props.user}
        possibleCyclesForUser={this.props.possibleCyclesForUser}
      />
      {this.props.updateRatingExamMessage.text !== '' &&
        this.props.updateRatingExamMessage.type === 'success' && (
          <div className={`message-${this.props.updateRatingExamMessage.type}`}>
            {this.props.updateRatingExamMessage.text}
          </div>
        )}
    </div>
  );

  canUpdate = () => {
    if (this.props.user && this.props.user.updateRequest) {
      const updateRequest = JSON.parse(this.props.user.updateRequest);

      if (updateRequest.lastUpdateDate) {
        const dateNow = moment();
        const dateUpdate = moment(updateRequest.lastUpdateDate);
        const diff = dateNow.diff(dateUpdate, 'days');
        if (diff < 30) {
          return false;
        }
      }
      return true;
    }
    return true;
  };

  getRatingExamText = () => {
    const { user, possibleCyclesForUser } = this.props;

    if (user && user.id && possibleCyclesForUser.length > 0) {
      const ratingExam = user.ratingExam ? user.ratingExam : user.rank;
      const userInfo = `${ratingExam} Exam - `;
      const examDate = this.getUserExamDate(possibleCyclesForUser, user);
      return userInfo + examDate;
    }
    return '';
  };

  getUserExamDate = (possibleCyclesForUser, user) => {
    let cycle = null;

    if (user.cycleSelected) {
      cycle = possibleCyclesForUser.find(
        (c) => Number(c.id) === Number(user.cycleSelected),
      );
    }
    if (!cycle) {
      cycle = possibleCyclesForUser.find((c) => c.isActive === true);
    }

    let examDate = cycle[`date${user.rank}`];
    if (examDate) {
      const splitedDate = examDate.split('-');
      const month = parseInt(splitedDate[1], 10) - 1;
      examDate = `${monthNames[month]} ${splitedDate[0]}`;
    } else {
      examDate = '';
    }
    return examDate;
  };

  renderEmailInput = () => (
    <div className="field field-input">
      <div className="field-label">Email</div>
      <div
        className={
          this.state.emailValidInput
            ? 'false-input'
            : 'false-input invalid-field'
        }
      >
        <Input
          className={
            this.state.allowEditEmail
              ? 'my-profile-input'
              : 'my-profile-input disabled-field'
          }
          placeholder={this.props.user ? this.props.user.email : ''}
          disabled={!this.state.allowEditEmail}
          id="email-input"
          value={this.state.email}
          onChange={(e) => this.handleEmailChange(String(e.target.value))}
          type="email"
        />
        {this.props.updateEmailWaiting && (
          <CircularLoading className="loading-gif-waiting" />
        )}
        {/* {!this.state.allowEditEmail && !this.props.updateEmailWaiting && (
            <i
              className="material-icons material-icons-outlined edit-icon"
              onClick={this.handleEditEmailClick}
            >
              edit
            </i>
          )}
          {this.state.allowEditEmail && !this.props.updateEmailWaiting && (
            <i
              className="material-icons edit-icon"
              onClick={this.validateEmail}
            >
              check
            </i>
          )} */}
      </div>
      {this.props.updateEmailMessage.text !== '' && (
        <div className={`message-${this.props.updateEmailMessage.type}`}>
          {this.props.updateEmailMessage.text}
        </div>
      )}
    </div>
  );

  renderUsernameInput = () => (
    <div className="field field-input">
      <div className="field-label">Username</div>
      <div
        className={
          this.state.usernameValidInput
            ? 'false-input'
            : 'false-input invalid-field'
        }
      >
        <Input
          id="username-input"
          className={
            this.state.allowEditUsername
              ? 'my-profile-input'
              : 'my-profile-input disabled-field'
          }
          placeholder={this.props.username ? this.props.username : ''}
          disabled={!this.state.allowEditUsername}
          value={this.state.username}
          onChange={(e) => this.handleUsernameChange(String(e.target.value))}
        />
        {this.props.updateUsernameWaiting && (
          <CircularLoading className="loading-gif-waiting" />
        )}
        {!this.state.allowEditUsername && !this.props.updateUsernameWaiting && (
          <i
            className="material-icons material-icons-outlined edit-icon"
            onClick={this.handleEditUsernameClick}
          >
            edit
          </i>
        )}
        {this.state.allowEditUsername && !this.props.updateUsernameWaiting && (
          <i
            className="material-icons edit-icon"
            onClick={this.validateUsername}
          >
            check
          </i>
        )}
      </div>
      {this.props.updateUsernameMessage.text !== '' && (
        <div className={`message-${this.props.updateUsernameMessage.type}`}>
          {this.props.updateUsernameMessage.text}
        </div>
      )}
      {this.state.usernameInputError && (
        <div className="message-error">{this.state.usernameInputError}</div>
      )}
      {this.state.isEmail ? (
        <div className="message-error">Emails can't be used as username</div>
      ) : null}
    </div>
  );

  renderTcpaTerms = () => (
    <div className="terms">
      <small>
        By submitting this form, I agree that Kaplan North America, LLC may
        contact me regarding educational services by telephone and/or text
        message utilizing automated technology at the telephone number(s)
        provided above. I understand this consent is not required to sign up for
        a free trial or purchase goods or services from Kaplan North America,
        LLC. If I reside outside the U.S., I consent to the transfer of my data
        to the U.S.{' '}
        <a
          className="terms-link"
          href="https://kaplan.com/privacy-policy"
          target="_blank"
          rel="noreferrer"
        >
          <strong>Privacy Policy</strong>
        </a>{' '}
        governs the submission and handling of this data.
        <br />
        <div>
          <input
            type="checkbox"
            id="disclaimer-terms-privacy-my-profile"
            checked={this.state.disclaimer}
            onChange={() =>
              this.setState({ disclaimer: !this.state.disclaimer })
            }
          />
          <label htmlFor="disclaimer-terms-privacy-my-profile">
            I agree to the{' '}
            <a
              className="terms-link"
              href="https://promotionwingman.com/terms-of-service/"
              target="_blank"
              rel="noreferrer"
            >
              <strong>Terms</strong>
            </a>{' '}
            and{' '}
            <a
              className="terms-link"
              href="https://kaplan.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              <strong>Privacy Policy.</strong>
            </a>
          </label>
          <br />
          <br />
        </div>
        <div>
          {this.state.isEditingPersonalData && !this.state.disclaimer && (
            <span className="isRequired">
              Read the above Terms and Privacy Policy to confirm your agreement.
            </span>
          )}
        </div>
      </small>
    </div>
  );

  isValidPhoneNumber = (phoneNumber) => {
    // Remove all non-digit characters
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    // Must be between 8 and 14 digits (supports international numbers)
    return digitsOnly.length >= 8 && digitsOnly.length <= 14;
  };

  renderPhoneNumberInput = () => (
    <div className="phone-number-container">
      <div className="field country-code">
        <div className="field-label">
          {this.state.isEditingPersonalData
            ? 'Country Code (*)'
            : 'Country Code'}
        </div>
        <Dropdown
          isOpen={this.state.countryCodeIsOpen}
          toggle={this.handleCountryCodeClick}
          className="my-profile-selector"
          disabled={!this.state.isEditingPersonalData}
        >
          <DropdownToggle
            disabled={!this.state.isEditingPersonalData}
            className={
              this.state.isEditingPersonalData &&
              !this.state.countryCode &&
              this.state.showErrors
                ? 'my-profile-dropdown-toggle invalid-field'
                : 'my-profile-dropdown-toggle'
            }
          >
            <span
              className={
                this.state.isEditingPersonalData
                  ? 'option-title'
                  : 'option-title-disabled'
              }
            >
              {this.state.countryCode ? this.state.countryCode : ``}
            </span>
            {this.state.isEditingPersonalData &&
              (this.state.countryCodeIsOpen ? (
                <i className="icon-expand select-icon rotate down" />
              ) : (
                <i className="icon-expand select-icon rotate" />
              ))}
          </DropdownToggle>
          <DropdownMenu>
            {countryCodes.map((countryCode, index) => (
              <DropdownItem
                key={index}
                className="drop-item"
                onClick={() => this.handleCountryCode(countryCode.dial_code)}
              >
                {`${countryCode.code} (${countryCode.dial_code})`}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="field field-input phone-number">
        <div className="field-label">
          {this.state.isEditingPersonalData
            ? 'Phone Number (*)'
            : 'Phone Number'}
        </div>
        <div
          className={
            this.state.isEditingPersonalData &&
            !this.state.phoneNumber &&
            this.state.showErrors
              ? 'false-input invalid-field'
              : 'false-input'
          }
        >
          <Input
            id="phone-number-input"
            maxLength={16} // 12 digits + 4 characters for formatting
            className={
              this.state.isEditingPersonalData
                ? 'my-profile-input'
                : 'my-profile-input disabled-field'
            }
            disabled={!this.state.isEditingPersonalData}
            placeholder={
              this.props.user.phoneNumber ? this.props.user.phoneNumber : ''
            }
            value={this.state.phoneNumber}
            onChange={(e) => this.handlePhoneNumber(String(e.target.value))}
          />
        </div>
      </div>
    </div>
  );

  renderEditPersonalData = () => {
    const isRequired =
      !this.state.countryCode ||
      !this.state.currentEnrollmentStatus ||
      !this.state.highestEducationLevel ||
      !this.state.phoneNumber ||
      (this.state.phoneNumber &&
        this.isValidPhoneNumber(this.state.phoneNumber) &&
        this.state.phoneNumber != this.props.user.phoneNumber &&
        !this.state.disclaimer) ||
      (this.state.phoneNumber &&
        !this.isValidPhoneNumber(this.state.phoneNumber)) ||
      (this.validaUserEnrollmentToDate(this.state.currentEnrollmentStatus) &&
        (!this.state.nameCurrentEducationalInstitution ||
          !this.state.estimatedDegreeCompletionDate));

    return (
      <div className="edit-personal-data">
        {this.state.isEditingPersonalData && this.renderTcpaTerms()}
        {this.props.updatePersonalDataMessage.text !== '' && (
          <div
            className={`message-${this.props.updatePersonalDataMessage.type}`}
          >
            {this.props.updatePersonalDataMessage.text}
          </div>
        )}
        <div className="field change-password-footer edit-personal-data">
          <div
            onClick={this.handleEditPersonalData}
            className="change-password-option link"
          >
            <span>
              {this.state.isEditingPersonalData
                ? 'Close'
                : 'Edit Personal Data'}
            </span>
          </div>
          {this.state.isEditingPersonalData && (
            <button
              className={
                !this.state.disclaimer ||
                isRequired ||
                (!this.state.disclaimer && isRequired)
                  ? 'btn btn-primary change-password-button disabled-btn'
                  : 'btn btn-primary change-password-button'
              }
              onClick={() => {
                if (
                  !this.state.disclaimer ||
                  isRequired ||
                  (!this.state.disclaimer && isRequired)
                ) {
                  this.setState({ showErrors: true });
                } else {
                  this.setState({ showErrors: false });
                  this.submitPersonalData();
                }
              }}
            >
              Save Changes
            </button>
          )}
        </div>
      </div>
    );
  };

  renderPasswordInput = (type) => (
    <div className="field field-input fade-in">
      <div className="field-label">
        {`${type} password`}
        <span className="mandatory">*</span>
        {type === 'new' && (
          <i
            className="material-icons warning-icon pointer warning-icon-password"
            id="warning-icon"
          >
            error_outline
            {this.renderToolTip()}
          </i>
        )}
      </div>
      <div className="false-input">
        <Input
          className="my-profile-input pass-input"
          type={
            type === 'new'
              ? this.state.showPassword
                ? 'text'
                : 'password'
              : 'password'
          }
          value={
            type === 'old' ? this.state.oldPassword : this.state.newPassword
          }
          onChange={(e) => {
            if (type === 'old') {
              this.handleOldPasswordChange(e.target.value);
            } else {
              this.handleNewPasswordChange(e.target.value);
            }
          }}
        />
        {type === 'new' && (
          <i
            className="material-icons material-icons-outlined password-icon"
            onClick={this.handleShowPassword}
          >
            {this.state.showPassword ? 'visibility_off' : 'visibility'}
          </i>
        )}
      </div>
    </div>
  );

  handleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  componentDidMount() {
    const uploadButton = document.querySelector('#upload-fake');
    const realInput = document.querySelector('#upload-real');
    uploadButton.addEventListener('click', () => {
      realInput.click();
    });
    this.props.getAvailableQualForDailyQuiz();
  }

  // RENDER PHOTO INPUT FUNCTION
  renderPhotoInput = () => (
    <div className="photo-input-container">
      <div className="photo-input">
        <div className="image-container">
          {!this.props.user.imgUrl && <i className="icon-profile avatar" />}
          {this.props.user.imgUrl && (
            <img
              alt=" "
              className="profile-avatar"
              height="200"
              width="200"
              src={this.props.user.imgUrl}
            />
          )}
        </div>
        <div className="content-body">
          <div className="label">Avatar</div>
          <button
            className="btn btn-outline-primary upload-btn"
            id="upload-fake"
          >
            Upload New Image
            <input
              type="file"
              id="upload-real"
              className="upload-photo-input d-none"
              onChange={(e) => this.handleFileChange(e.target.files[0])}
              accept=".png, .jpg, .jpeg"
            />
          </button>
        </div>
        {this.state.selectedImage && (
          <AvatarEditorContainer
            selectedImage={this.state.selectedImage}
            onClose={() => this.handleFileChange(null)}
            onSave={(imgFile) => this.saveImg(imgFile)}
            message={this.props.uploadImageMessage}
            waiting={this.props.uploadImageWaiting}
            setUploadImageMessage={this.props.setUploadImageMessage}
          />
        )}
      </div>
      {this.props.uploadImageMessage.text !== '' &&
        this.props.uploadImageMessage.type === 'success' && (
          <div
            className={`message-${this.props.uploadImageMessage.type} upload-image-message`}
          >
            {this.props.uploadImageMessage.text}
          </div>
        )}
    </div>
  );

  // RENDER PROFILE PRIVACY SECTION
  renderProfilePrivacySection = () => (
    <div className="profile-privacy">
      <div className="profile-privacy-header">
        <div className="label">Profile Privacy</div>
      </div>
      <div className="profile-privacy-body">
        <div className="radio-group">
          <div className="radio-container">
            {this.props.user.id &&
            this.props.user.profilePrivacy &&
            this.props.user.profilePrivacy === 'public' ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() => this.toggleCheckedRadio('public')}
              >
                radio_button_unchecked
              </i>
            )}
            <div className="radio-label">Public</div>
          </div>
          <div className="radio-container">
            {this.props.user.id &&
            this.props.user.profilePrivacy &&
            this.props.user.profilePrivacy === 'private' ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() => this.toggleCheckedRadio('private')}
              >
                radio_button_unchecked
              </i>
            )}
            <div className="radio-label">Private</div>
          </div>
          <div className="radio-container">
            {this.props.user.id &&
            this.props.user.profilePrivacy &&
            this.props.user.profilePrivacy === 'friends' ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() => this.toggleCheckedRadio('friends')}
              >
                radio_button_unchecked
              </i>
            )}
            <div className="radio-label">Friends Only</div>
          </div>
        </div>
      </div>
      {this.props.updateProfilePrivacyMessage.text !== '' && (
        <div
          className={`message-${this.props.updateProfilePrivacyMessage.type}`}
        >
          {this.props.updateProfilePrivacyMessage.text}
        </div>
      )}
    </div>
  );

  // VALIDATE FUNCTIONS

  validateUsername = () => {
    const usernameContainsProfanity = containsProfanity(this.state.username);
    const isEmail = validateE({ value: this.state.username });

    if (
      this.state.username.length >= 6 &&
      !isEmail &&
      !usernameContainsProfanity
    ) {
      this.setState({ allowEditUsername: false });
      this.props.updateUsername(this.state.username);
      this.setState({ usernameValidInput: true });
    } else {
      this.setState({ usernameValidInput: false });
      if (isEmail) {
        this.setState({ isEmail: true });
      }
    }

    if (usernameContainsProfanity) {
      this.setState({ usernameInputError: 'Profanity is not allowed' });
    }

    if (this.state.username.length < 6) {
      this.setState({
        usernameInputError: 'Username must be at least 6 characters',
      });
    }
  };

  validateEmail = () => {
    const emailError = !document.getElementById('email-input').validity.valid;
    if (!emailError) {
      this.setState({ allowEditEmail: false });
      this.props.updateEmail(this.state.email);
    } else {
      this.setState({ emailValidInput: false });
    }
  };

  renderToolTip() {
    return (
      <UncontrolledTooltip
        placement="left-start"
        target="warning-icon"
        autohide={false}
        style={{ maxWidth: '500px' }}
      >
        <div className="tooltip-container">
          <span className="tooltip-message">
            Your password must have at least 8 characters and 3 of the 4 next
            requirements:
          </span>
          <ul>
            <li>Numeric digits (0-9)</li>
            <li>Uppercase alphabetic characters</li>
            <li>Lowercase alphabetic characters</li>
            <li>Non-alphanumeric special characters such as !, $, # or %.</li>
          </ul>
        </div>
      </UncontrolledTooltip>
    );
  }

  validateNewPassword = () => {
    const oldPass = this.state.oldPassword;
    const newPass = this.state.newPassword;
    const criteria = validatePassword(this.state.newPassword);
    if (criteria >= 3 && this.state.newPassword.length >= 8) {
      this.props.updatePassword(oldPass, newPass);
    } else {
      this.setState({ validatePasswordError: true });
      setTimeout(() => {
        this.setState({ validatePasswordError: false });
      }, 5000);
    }
  };

  changeCycle = () => {
    if (this.state.cycleSelected) {
      this.props.setUserCycle(this.state.cycleSelected.id);

      this.setState({
        cycleSelected: false,
      });
    }
  };

  submitPersonalData = () => {
    const personalData = {
      phoneNumber: this.state.phoneNumber,
      countryCode: this.state.countryCode,
      currentEnrollmentStatus: this.state.currentEnrollmentStatus,
      highestEducationLevel: this.state.highestEducationLevel,
      nameCurrentEducationalInstitution:
        this.state?.nameCurrentEducationalInstitution?.trim(),
      estimatedDegreeCompletionDate: this.state.estimatedDegreeCompletionDate
        ? this.state.estimatedDegreeCompletionDate.getTime()
        : null,
    };
    this.props.updatePersonalData(personalData);
    this.setState({ isEditingPersonalData: false, disclaimer: false });
  };

  SubmitRatingExamChange = (id, rate, rank, dutyState, cycleSelected) => {
    const newCycle = cycleSelected?.id || cycleSelected || null;
    this.props.updateRatingExam(id, rate, rank, dutyState, newCycle);
  };

  renderChange(isPassword) {
    let titleChange = '';
    let disabled = false;
    let titleSave = '';
    const viewButton = isPassword
      ? this.state.isEditingPassword
      : this.state.isEditingCycle;
    if (isPassword) {
      titleChange = this.state.isEditingPassword ? 'Close' : 'Change Password';
      disabled =
        this.state.newPassword === '' ||
        this.state.oldPassword === '' ||
        this.state.newPassword.length < 6 ||
        this.state.oldPassword.length < 6 ||
        this.props.updatePasswordWaiting ||
        this.props.updatePasswordMessage.text !== '';
      titleSave = 'Save password';
    } else {
      titleChange = 'close';
      disabled =
        !this.state.cycleSelected || this.props.dashboardHeaderInfoWaiting;
      titleSave = 'Change Cycle';
    }
    return (
      <div className="field change-password-footer">
        <div
          onClick={
            isPassword
              ? this.handleChangePasswordClick
              : this.handleEditingCycle
          }
          className="change-password-option link"
        >
          {titleChange}
        </div>
        {!isPassword && this.props.updateCycleMessage.text !== '' && (
          <div className={`message-${this.props.updateCycleMessage.type} ml-2`}>
            {this.props.updateCycleMessage.text}
          </div>
        )}
        {viewButton && (
          <button
            className="btn btn-primary change-password-button"
            disabled={disabled}
            onClick={isPassword ? this.validateNewPassword : this.changeCycle}
          >
            {(
              isPassword
                ? this.props.updatePasswordWaiting
                : this.props.dashboardHeaderInfoWaiting
            )
              ? 'loading'
              : titleSave}
          </button>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="my-profile-component">
        <Row className="header">
          <div className="title">My Profile</div>
          <button className="btn btn-outline-secondary rounded-lg collapse">
            View Profile
          </button>
        </Row>

        <Row className="body">
          <Col sm={6} className="left-column">
            {this.renderRatingExamInput()}
            {this.renderTimeZoneSelector()}
            {this.renderEmailInput()}
            <FlashcardOnlySection
              flashcard={this.props.flashcard}
              onFlashcardChange={this.flashcardCheckedRadio}
              flashcardOnlyMessage={this.props.flashcardOnlyMessage}
              setFlashSectionChoose={this.props.setFlashSectionChoose}
              flashChoose={this.props.flashChoose}
            />
            {/* <ChooseQualDailyQuiz
              highlight={
                this.state.highlightedSection === 'chooseQualForDailyQuiz'
              }
              quals={this.props.availableQualForDailyQuiz}
              qualIdForDailyQuiz={this.props.user?.userSetting?.qualDailyQuiz}
              updateUserSettingQualForDailyQuiz={
                this.props.updateUserSettingQualForDailyQuiz
              }
              userSettingQualForDailyQuizMessage={
                this.props.userSettingQualForDailyQuizMessage
              }
              loadingUpdateUserSettingQualForDailyQuiz={
                this.props.loadingUpdateUserSettingQualForDailyQuiz
              }
              setUserSettingQualForDailyQuizMessage={
                this.props.setUserSettingQualForDailyQuizMessage
              }
              flashChoose={this.props.flashChoose}
              setFlashSectionChoose={this.props.setFlashSectionChoose}
            /> */}

            <StudySpeedSettingsSection
              studySpeedSetting={this.props.user?.userSetting?.studySpeed}
              setStudySpeedSettings={this.props.setStudySpeedSettings}
              setStudySpeedSettingsMessage={
                this.props.setStudySpeedSettingsMessage
              }
              studySpeedSettingsMessage={this.props.studySpeedSettingsMessage}
              isLoadingStudySpeedSettings={
                this.props.isLoadingStudySpeedSettings
              }
            />

            {this.state.isEditingPassword && (
              <div className="password-inputs">
                {this.renderPasswordInput('old')}
                {this.renderPasswordInput('new')}
              </div>
            )}
            {this.renderChange(true)}
            {this.props.updatePasswordMessage.text !== '' &&
              this.state.isEditingPassword && (
                <div
                  className={`message-${this.props.updatePasswordMessage.type} mt-1`}
                >
                  {this.props.updatePasswordMessage.text}
                </div>
              )}
            {this.state.validatePasswordError &&
              this.state.isEditingPassword && (
                <div className="message-error mt-1">
                  Password doesn't meet criteria
                </div>
              )}
          </Col>
          <Col sm={6} className="right-column">
            {this.renderPhotoInput()}
            {this.renderUsernameInput()}
            {this.renderPhoneNumberInput()}
            {this.renderCurrentEnrollmentStatus()}
            {this.renderHighestEducationLevel()}
            {this.validaUserEnrollmentToDate(
              this.state.currentEnrollmentStatus,
            ) && this.renderNameCurrentEducationalInstitution()}
            {this.validaUserEnrollmentToDate(
              this.state.currentEnrollmentStatus,
            ) && this.renderEstimatedDegreeCompletionDate()}
            {this.renderEditPersonalData()}
            {this.renderProfilePrivacySection()}
          </Col>
        </Row>
      </div>
    );
  }
}

export default MyProfile;
